module.exports = __webpack_public_path__ + "img/match3.4de859a6.jpg";